module.exports = __webpack_public_path__ + "static/media/VLC_BG.b75f8a7f.jpg";